import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import * as mediaQuery from "components/MediaQuery";
import { noScrollBar } from "styles/commonStyles";
import { calcRem } from "styles/theme";

export const Container = styled.div<{ center?: boolean }>`
  width: 100vw;
  min-height: 100dvh;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 998;
  background-color: rgba(0, 0, 0, 0.8);
  ${FLEX.FlexCenterStart};
  overflow-y: auto;
  ${noScrollBar};
  &.full-width .small-popup-wrapper {
    width: 100%;
  }

  button {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* announcement popup style */
  .features-popup {
    width: 1149px !important;
    max-width: calc(100% - 20px) !important;
    position: relative !important;
  }
  .features-popup .big-popup-template-inner {
    width: 100% !important;
    max-width: 980px !important;
  }

  ${mediaQuery.isMobile} {
    padding: 20px;
    ${({ center }) =>
      center &&
      `
    ${FLEX.FlexCenterCenter};
    
    `}
  }
`;

/**
 * big popup
 */

export const Modal = styled.section`
  width: 100%;
  max-width: 750px;
  background-color: ${({ theme }) => theme.COLORS.PRIMARY2};
  padding: 15px;
  border-radius: 4px;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 30px 0;

  ${mediaQuery.isMobile} {
    min-width: 95%;
    max-width: calc(100% - 12px);
    margin: 10px 0;
    border-radius: 8px;
  }
`;

export const Inner = styled.div`
  width: 600px;
  max-width: 100%;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  padding: 30px 0 35px;

  ${mediaQuery.isMobile} {
    min-width: 100%;
  }
`;

/**
 * small popup
 */

export const SmallContainer = styled.div`
  width: 100%;
  height: 100%;
  ${FLEX.FlexCenterCenter};
`;
export const SmallWrapper = styled.div`
  box-sizing: border-box;
  background-color: ${({ theme }) =>
    theme.value === "light" ? theme.COLORS.PRIMARY2 : theme.COLORS.PRIMARY1};
  border-radius: 10px;
  /* overflow: hidden; */
  position: relative;
  padding-top: 10px;

  ${mediaQuery.isDefault} {
    width: fit-content;
    max-width: 580px;
  }

  ${mediaQuery.isMobile} {
    width: 90vw;
  }
`;

export const SmallInner = styled.div`
  padding: 30px;
  box-sizing: border-box;
  width: 100%;
  ${mediaQuery.isMobile} {
    padding: 15px;
  }
`;

export const SmallContents = styled.div`
  padding: 20px 0;
  max-height: 70vh;
  overflow-y: auto;
`;

export const SmallTitleWrapper = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 6px;
  width: 100%;
  color: ${({ theme }) => theme.COLORS.WHITE};

  > * {
    width: 100%;
  }
  h2 {
    font-size: ${calcRem(22)};
    font-weight: 500;
    line-height: 1.2;
  }

  .subtitle {
    color: ${({ theme }) =>
      theme.value === "light" ? `${COLORS.BLACK}80` : "rgba(255,255,255,0.41)"};
    font-size: ${calcRem(14)};
    line-height: 1.4;
  }
`;

export const SmallButtonWrapper = styled.div`
  background-color: ${({ theme }) =>
    theme.value === "light" ? theme.COLORS.PRIMARY3 : "#131b33"};
  ${FLEX.FlexCenterCenter};
  padding: 20px;
  gap: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  color: ${({ theme }) => theme.COLORS.WHITE}50;
  path {
    stroke: ${({ theme }) => theme.COLORS.WHITE}50 !important;
  }
`;

export const SmallDeactivateTitle = styled(SmallTitleWrapper)`
  ${FLEX.FlexCenterCenter};
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-weight: 500;
`;

export const ButtonWrapper = styled.div`
  ${FLEX.FlexCenterCenter};
  gap: 10px;

  button {
    min-width: 64px;
  }
`;
